var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.78 97.79",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.89,0C21.93,0,0,21.93,0,48.89s21.93,48.89,48.89,48.89,48.89-21.93,48.89-48.89S75.85,0,48.89,0Zm0,90.18c-22.77,0-41.29-18.52-41.29-41.29S26.12,7.6,48.89,7.6s41.29,18.52,41.29,41.29-18.52,41.29-41.29,41.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,21.88c-1.15-.46-2.36-.7-3.58-.7-2.43,0-4.87,.93-6.72,2.78L27.96,56.39c-.65,.65-.65,1.71,0,2.37l11.07,11.07c.33,.33,.76,.49,1.18,.49s.86-.16,1.18-.49l32.42-32.42c3.71-3.71,3.71-9.73,0-13.44-.93-.93-2-1.62-3.14-2.09Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.41,62.41c-.48-.48-1.15-.64-1.8-.44-.65,.2-1.11,.71-1.23,1.38l-2.17,11.36c-.11,.59,.08,1.19,.5,1.62,.34,.33,.79,.51,1.25,.51,.12,0,.25-.01,.37-.04l11.19-2.34c.65-.14,1.16-.6,1.35-1.24,.19-.64,.02-1.3-.45-1.78l-9.02-9.02Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate1);
export default __webpack_public_path__ + "static/media/Update_1.9672a0c249f4d26ebca800ba1a900745.svg";
export { ForwardRef as ReactComponent };